import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';


class FlightReportLegDelayJustifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      justified_time: '00:00:00',
      flight_omni_id: null,
      flight_ptbr_id: null,
      description: null,
      reason_omni: null,
      session_omni: null,
      reason_ptbr: null,
      code_ptbr: null,
      flight_ptbr_selects: [],
      flight_omni_selects: [],
      codes_ptbr_select: [],
      flight_report_leg_delay_edit: {},
      flight_report_leg_delay_justifications: {},
    };

    this.addJustification = this.addJustification.bind(this);
    this.deleteJustification = this.deleteJustification.bind(this);
    this.exportOmniJustification = this.exportOmniJustification.bind(this);
    this.exportPtbrJustification = this.exportPtbrJustification.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeJustificationPtbr(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.clearJustificationPtbr();
    } else {
      this.props.handleAlert('', '', 'open');
      change[name] = event.value;

      var datasave = {
        justification_ptbr: event.value,
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/justificativas/ptbr/codigos/lista', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({codes_ptbr_select: responseJson.data});
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(newProps.flight_report_leg_delay_edit.type === 'departure'){
      this.setState({
        flight_ptbr_selects: newProps.ptbr_departure_selects,
        flight_omni_selects: newProps.omni_departure_selects,
        flight_ptbr: newProps.flight_ptbr,
        flight_report_leg_delay_edit: newProps.flight_report_leg_delay_edit,
        justified_time: newProps.flight_report_leg_delay_edit.delay_time_remaining,
        flight_report_leg_delay_justifications: newProps.flight_report_leg_delay_justifications,
        flight_report_leg_delay_id: newProps.flight_report_leg_delay_edit.id,
      });
    } else {
      this.setState({
        flight_ptbr_selects: newProps.ptbr_flight_selects,
        flight_omni_selects: newProps.omni_flight_selects,
        flight_ptbr: newProps.flight_ptbr,
        flight_report_leg_delay_edit: newProps.flight_report_leg_delay_edit,
        justified_time: newProps.flight_report_leg_delay_edit.delay_time_remaining,
        flight_report_leg_delay_justifications: newProps.flight_report_leg_delay_justifications,
        flight_report_leg_delay_id: newProps.flight_report_leg_delay_edit.id,
      });
    }
  }

  addJustification(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      flight_report_id: this.state.flight_report_leg_delay_edit.flight_report_id,
      flight_report_leg_id: this.state.flight_report_leg_delay_edit.flight_report_leg_id,
      flight_report_leg_delay_id: this.state.flight_report_leg_delay_edit.id,
      justified_time: this.state.justified_time,
      flight_omni_id: this.state.flight_omni_id,
      flight_ptbr_id: this.state.flight_ptbr_id,
      description: this.state.description,
      code_ptbr: this.state.code_ptbr,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/atraso/justificativa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshJustificationsModal(responseJson);
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteJustification(id) {
    if(window.confirm('Tem certeza que gostaria de remover esta justificativa atraso?')) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/atraso/justificativa', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.refreshJustificationsModal(responseJson);
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  exportOmniJustification() {
    var self = this;
    var url = "/exportar/justificativas/omni";
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url , { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.props.handleAlert('', '', 'closed');
        }
      });
    });
  }

  exportPtbrJustification() {
    var self = this;
    var url = "/exportar/justificativas/ptbr";
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url , { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.props.handleAlert('', '', 'closed');
        }
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.addJustification}>
    <div className="row">
      <div className="col-md-3 form-group">
        <label><button type="button" onClick={() => this.exportOmniJustification()} className="btn btn-success btn-xs"><i className="fa fa-fw fa-file-pdf-o"></i></button> Justificativa OMNI:</label>
        <Select
          className="form-field-name"
          name="flight_omni_id"
          value={this.state.flight_omni_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'flight_omni_id')}
          options={this.state.flight_omni_selects}
          required
        />
      </div>
      <div className="col-md-3 form-group">
        <label>Atraso justificado:</label>
        <InputMask value={this.state.justified_time}  maskChar={null} name="justified_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'justified_time')} placeholder="" required />
      </div>
      <div className="col-md-6 form-group">
        <label>Descrição do atraso:</label>
        <input value={this.state.description}  maskChar={null} name="description" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'description')} placeholder="" required />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar justificativa</button>
  </form>
  <hr/>
  <h3 className="page-title">Razões cadastradas</h3>
  <hr/>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>Tempo justificado</th>
          <th>Descrição</th>
          <th>Justificativa OMNI</th>
          <th>Motivo OMNI</th>
          <th>Setor OMNI</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
      {Object.keys(self.state.flight_report_leg_delay_justifications).map(function(k) {
        var srldj = self.state.flight_report_leg_delay_justifications[k];
        return (
          <tr>
            <td>{srldj.justified_time}</td>
            <td>{srldj.description}</td>
            <td>{srldj.flight_omni.name}</td>
            <td>{srldj.flight_omni.reason}</td>
            <td>{srldj.flight_omni.session}</td>
            <td className="text-center">
              <button onClick={() => self.deleteJustification(srldj.id)} className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default FlightReportLegDelayJustifications;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportLegDelayJustifications.js